import React from 'react';
import PropTypes from 'prop-types';

import { usePlayerSearchSavedStatus } from './usePlayerSearchSavedStatus';

// Bridges the class-based SearchResults to the saved-status hook: it owns the single per-page-delta
// hydration for the whole player list and hands each row's status down through a render prop.
const PlayerSearchSavedStatusProvider = ({ playerIds, enabled, children }) => {
    const savedStatus = usePlayerSearchSavedStatus(playerIds, { enabled });
    return <>{children(savedStatus)}</>;
};

PlayerSearchSavedStatusProvider.propTypes = {
    playerIds: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
    enabled: PropTypes.bool,
    children: PropTypes.func.isRequired,
};

PlayerSearchSavedStatusProvider.defaultProps = {
    playerIds: [],
    enabled: false,
};

export default PlayerSearchSavedStatusProvider;
